module.exports = {"431122100":"白牙市镇","431122101":"大庙口镇","431122102":"紫溪市镇","431122103":"横塘镇","431122104":"石期市镇","431122105":"井头圩镇","431122106":"端桥铺镇","431122107":"鹿马桥镇","431122108":"芦洪市镇","431122109":"新圩江镇","431122110":"花桥镇","431122111":"大盛镇","431122112":"南桥镇","431122201":"川岩乡","431122202":"水岭乡","431122400":"大庙口林场","431122401":"黄泥洞林场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/431122.json
// module id = 1741
// module chunks = 0